import requestFunctions from "../../functions/requestFunctions";


export const state = {
  TARIFFS_ITEM: {},
  TARIFFS_LIST: [],
  TARIFFS_TABLE_DATA: [],
  TARIFFS_LIST_DATA: [],
  TARIFFS_TOTAL_ROWS: 0
}

export const getters = {
  GET_TARIFFS_ITEM: (state) => {
    return state.TARIFFS_ITEM;
  },
  GET_TARIFFS_LIST_DATA: (state) => {
    return state.TARIFFS_LIST_DATA;
  },
  GET_TARIFFS_TABLE_DATA: (state) => {
    return state.TARIFFS_TABLE_DATA;
  },
  GET_TARIFFS_TOTAL_ROWS: (state) => {
    return state.TARIFFS_TOTAL_ROWS;
  }
}

export const mutations = {
  UPDATE_TARIFFS_ITEM(state, item) {
    state.TARIFFS_ITEM = item;
  },
  UPDATE_TARIFFS_LIST(state, list) {

    state.TARIFFS_LIST = list.data;
    state.TARIFFS_TOTAL_ROWS = list.total;

    list = list.data;

    state.TARIFFS_TABLE_DATA = [];
    state.TARIFFS_LIST_DATA = [];

    list.forEach(el => {

      let status = '';

      if(el.status === 'active'){
        status = 'Активный'
      }
      if(el.status === 'wait'){
        status = 'Ожидает активации'
      }
      if(el.status === 'disabled'){
        status = 'Отключен'
      }

      let user_data = '';
    
      if(el.profile_fullname !== null){
        user_data = el.profile_fullname;
      }
      
      if(el.user_phone !== null ){
        if(user_data !== ''){
          user_data = user_data + ', ';
        }
        user_data = user_data + el.user_phone;
      }

      state.TARIFFS_TABLE_DATA.push({
        'id'     : el.id ? el.id : null,
        'name'   : el.name ? el.name : null,
        'description' : el.description ? el.description : null, 
        'user_data'   : user_data,
        'started_at'  : el.started_at ? el.started_at : null,
        'finished_at' : el.finished_at ? el.finished_at : null,
        'created_at'  : el.created_at ? el.created_at : null,
        'updated_at'  : el.updated_at ? el.updated_at : null,
        'status' : status,
        'uuid'   : el.uuid ? el.uuid : null
      });    

      state.TARIFFS_LIST_DATA.push({
        id   : el.id   ? el.id   : null,
        name : el.name ? el.name : null,
      });

    });
  },
}


export const actions = {

  async FETCH_TARIFFS_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/tariffs/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_TARIFFS_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_TARIFFS_LIST({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/tariffs';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_TARIFFS_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_TARIFFS_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/tariffs';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_TARIFFS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/tariffs/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_TARIFFS_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/tariffs/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}